import { createFileRoute } from "@tanstack/react-router";
import { ForgotPasswordScreen } from "@modules/password-reset/views";

// « Mot de passe oublié »: PUBLIC. The sign-in screen's link points here.
export const Route = createFileRoute("/account-recovery")({
  component: ForgotPasswordScreen,
});
